export enum SharedUiGapsName {
    GAP_0 = 'gap-0',
    GAP_1 = 'gap-1',
    GAP_S = 'gap-2',
    GAP_M = 'gap-3',
    GAP_L = 'gap-4',
    GAP_5 = 'gap-5',
    GAP_6 = 'gap-6',
    GAP_8 = 'gap-8',
    GAP_10 = 'gap-10',
    GAP_12 = 'gap-12',
    GAP_14 = 'gap-14',
    GAP_16 = 'gap-16',
    GAP_18 = 'gap-18',
    GAP_20 = 'gap-20',
    GAP_24 = 'gap-24',
    GAP_PAGE_BOUNDS = 'gap-page-bounds',
    GAP_INTER_BLOCK = 'gap-inter-block'
}
